
export const handleError = (response) => {
  
    switch (response.status) {       
        case 401:
            // Go to login
            return true;
            break;
       
    }
   
}